import React, { useEffect, useState } from 'react';
import { getExchangeRate } from '../utils/currencyConverter';

interface ExchangeRateDisclosureProps {
  className?: string;
  variant?: 'badge' | 'tooltip' | 'full';
}

export default function ExchangeRateDisclosure({
  className = '',
  variant = 'badge'
}: ExchangeRateDisclosureProps) {
  const [rate, setRate] = useState<number | null>(null);
  const [lastUpdate, setLastUpdate] = useState<Date>(new Date());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRate = async () => {
      try {
        const exchangeRate = await getExchangeRate();
        setRate(exchangeRate);
        setLastUpdate(new Date());
      } catch (error) {
        console.error('Error fetching exchange rate:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchRate();
  }, []);

  if (loading || !rate) {
    return null;
  }

  const timeString = lastUpdate.toLocaleTimeString('es-MX', {
    hour: '2-digit',
    minute: '2-digit'
  });

  // Variante Badge (compacto)
  if (variant === 'badge') {
    return (
      <span
        className={`badge bg-info text-dark ${className}`}
        title={`Última actualización: ${timeString}`}
        style={{ cursor: 'help' }}
      >
        <i className="fa fa-exchange-alt me-1"></i>
        1 USD = {rate.toFixed(2)} MXN
      </span>
    );
  }

  // Variante Tooltip (con ícono)
  if (variant === 'tooltip') {
    return (
      <div
        className={`d-inline-block ${className}`}
        title={`Tipo de cambio: 1 USD = ${rate.toFixed(2)} MXN (Actualizado: ${timeString})`}
        style={{ cursor: 'help' }}
      >
        <i className="fa fa-info-circle text-primary"></i>
      </div>
    );
  }

  // Variante Full (completa con fuente)
  return (
    <div className={`alert alert-info d-flex align-items-center ${className}`} style={{ fontSize: '0.9rem' }}>
      <i className="fa fa-info-circle me-2"></i>
      <div className="flex-grow-1">
        <strong>Tipo de Cambio:</strong> 1 USD = {rate.toFixed(2)} MXN
        <br />
        <small className="text-muted">
          Actualizado: {timeString} • Fuente:
          <a
            href="https://www.exchangerate-api.com"
            target="_blank"
            rel="noopener noreferrer"
            className="ms-1"
          >
            ExchangeRate-API
          </a>
        </small>
      </div>
    </div>
  );
}
